// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_er-0";
export var actionModalContentContainer = "_er-1";
export var createTagButton = "_er-2";
export var footerContainer = "_er-7";
export var fullWidthDivider = "_er-3";
export var hasCreateTagButton = "_er-4";
export var noCreateTagButton = "_er-5";
export var tagsContainer = "_er-6";
export var tagsModalContentContainer = "_er-8";